import React from 'react';

export const defaultDeviceInfo = {
  accessToken: null,
  branchId: null,
  deviceId: null,
  groupId: null,
  name: '',
  orientation: null,
  timeZone: '',
};

export const defaultProofs = {
  isBusy: false,
  lastSynched: null,
  data: [],
};

export const defaultAppState = {
  tid: null,
  localData: {
    error: null,
    isAuthenticated: false,
    token: '',
    user: '',
    config: {
      businessName: '',
      logo: '',
      logoFile: null,
      placeholderHorizontal: '',
      placeholderHorizontalFile: null,
      placeholderVertical: '',
      placeholderVerticalFile: null,
    },
  },
  deviceInfo: defaultDeviceInfo,
  proofs: defaultProofs,
  deviceMeta: null,
};

export const AppStateContext = React.createContext({
  appState: defaultAppState,
  setAppState: () => {},
});
